import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  process: {},
  changeData: {},
  seeState: { tab: 1 },
  seePublishData: {},
};

export const processSlice = createSlice({
  name: 'process',
  initialState,
  reducers: {
    setProcessData: (state, action) => {
      state.process = action.payload;
    },
    setChangeData: (state, action) => {
      state.changeData = action.payload;
    },
    setSeeState: (state, action) => {
      state.seeState = action.payload;
    },
    setSeePublishData: (state, action) => {
      state.seePublishData = action.payload;
    },
  },
});

export const { setProcessData, setChangeData, setSeeState, setSeePublishData } = processSlice.actions;
export const process = (state) => state.process.process;
export const changeData = (state) => state.process.changeData;
export const seeState = (state) => state.process.seeState;
export const seePublishData = (state) => state.process.seePublishData;
export default processSlice.reducer;
